import axiosInstance from "../../../interceptor/axiosInstance";
import {CLASSROOM_SUBJECTS, SUBJECTS} from "../../../routes/routeConstants/apiRoutes";
import {deserialize} from "serializr";
import Notification from "../../../shared/components/Notification";
import {NotificationTypes} from "../../../enums/notificationTypes";
import {PaginationModel} from "../../../models/PaginationModel/pagination.model";
import {ClassRoomSubjectModel, SubjectModel} from "../../../models/CourseModels/SubjectModel/subject.model";

export default class SubjectService {

    static getClassroomSubjectsList(
        queryParams: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ){
        return axiosInstance
            .get(CLASSROOM_SUBJECTS + queryParams)
            .then(response => {
                const classroomSubjects = deserialize(ClassRoomSubjectModel, response.data['class_room_subjects']);
                const pageMeta = deserialize(PaginationModel, response.data['meta']);
                onSuccess(classroomSubjects,pageMeta);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to fetch the classroom subjects list",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static createClassroomSubject(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ){
        return axiosInstance
            .post(CLASSROOM_SUBJECTS,data)
            .then(response => {
                const classroomSubject = deserialize(ClassRoomSubjectModel, response.data['class_room_subject']);
                onSuccess(classroomSubject);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to create the classroom subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateClassroomSubject(
        id: number,
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ){
        return axiosInstance
            .put(CLASSROOM_SUBJECTS+`/${id}`,data)
            .then(response => {
                const classroomSubject = deserialize(ClassRoomSubjectModel, response.data['class_room_subject']);
                onSuccess(classroomSubject);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the classroom subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static deleteClassroomSubject(
        id: number,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ){
        return axiosInstance
            .delete(CLASSROOM_SUBJECTS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to delete the classroom subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }


    static getSubjectsList(
        queryParams: string,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .get(SUBJECTS + queryParams)
            .then(response => {
                const subjects = deserialize(SubjectModel, response.data['subjects']);
                //const pageMeta = deserialize(PaginationModel, response.data['meta']);
                onSuccess(subjects);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to fetch the subjects list",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static createSubject(
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .post(SUBJECTS,data,{headers:{'Content-Type':'multipart/form-data'}})
            .then(response => {
                const subject = deserialize(SubjectModel, response.data['subject']);
                onSuccess(subject);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to create the subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static updateSubject(
        id:number,
        data: any,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .put(SUBJECTS+`/${id}`,data,{headers:{'Content-Type':'multipart/form-data'}})
            .then(response => {
                const subject = deserialize(SubjectModel, response.data['subject']);
                onSuccess(subject);
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to update the subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }

    static deleteSubject(
        id:number,
        onSuccess: Function,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance
            .delete(SUBJECTS+`/${id}`)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                Notification({
                    message: "Failed",
                    description: "Unable to delete the subject",
                    type: NotificationTypes.ERROR
                });
                onError(error);
            })
            .finally(onFinal)
    }
}
